/* eslint-disable no-param-reassign */
// Identificaciones
export const RFC_PATTERN = /^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{4})\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\w{2})([A|a|0-9]{1})$/;
export const CURP_PATTERN = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
export const INE_PATTERN = /^[A-Z]{6}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])(?:0[1-9]|1[1-9]|2[1-9]|3[12])[HM]{1}[0-9]{3}$/;
export const NUMERO_TELEFONICO_PATTERN = /^[0-9]{10}$/;
export const NOMBRES_PATTERN = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '-]+$/u;
export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/;
export const SLUG_PATTERN = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;

export const digitoVerificador = (curp17) => {
  const diccionario = '0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ';
  let lngSuma = 0.0;
  let lngDigito = 0.0;
  for (let i = 0; i < 17; i += 1) {
    lngSuma += diccionario.indexOf(curp17.charAt(i)) * (18 - i);
  }
  lngDigito = 10 - (lngSuma % 10);
  if (lngDigito === 10) {
    return '0';
  }
  return lngDigito.toString();
};

// TABLA PARA ASIGNAR VALORES A LOS CARACTERES QUE APARECEN EN
// EL NOMBRE AL QUE SE LE CALCULARA LA CLAVE DIFERENCIADORA DE HOMONIMO
const valoresCaracteresParaSumatoriaClaveHomonima = {
  ' ': '00',
  0: '00',
  1: '01',
  2: '02',
  3: '03',
  4: '04',
  5: '05',
  6: '06',
  7: '07',
  8: '08',
  9: '09',
  '&': '10',
  A: '11',
  B: '12',
  C: '13',
  D: '14',
  E: '15',
  F: '16',
  G: '17',
  H: '18',
  I: '19',
  J: '21',
  K: '22',
  L: '23',
  M: '24',
  N: '25',
  O: '26',
  P: '27',
  Q: '28',
  R: '29',
  S: '32',
  T: '33',
  U: '34',
  V: '35',
  W: '36',
  X: '37',
  Y: '38',
  Z: '39',
  Ñ: '40',
};

// TABLA DE VALORES QUE SE ASIGNAN A LA CLAVE DIFERENCIADORA DE
// HOMONIMIO EN BASE AL COEFICIENTE Y AL RESIDUO
const residuoCocienteACaracter = {
  0: '1',
  1: '2',
  2: '3',
  3: '4',
  4: '5',
  5: '6',
  6: '7',
  7: '8',
  8: '9',
  9: 'A',
  10: 'B',
  11: 'C',
  12: 'D',
  13: 'E',
  14: 'F',
  15: 'G',
  16: 'H',
  17: 'I',
  18: 'J',
  19: 'K',
  20: 'L',
  21: 'M',
  22: 'N',
  23: 'P',
  24: 'Q',
  25: 'R',
  26: 'S',
  27: 'T',
  28: 'U',
  29: 'V',
  30: 'W',
  31: 'X',
  32: 'Y',
  33: 'Z',
};

// B   A   C   G   9   1   1   2   2   1   E   Z   1
// 11  10  12  16  9   1   1   2   2   1   14  36
// TABLA DE VALORES PARA LO GENERACIÓN DEL CÓDIGO VERIFICADOR
// DEL REGISTRO FEDERAL DE CONTRIBUYENTES
const caracteresDigitoVerificador = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  G: 16,
  H: 17,
  I: 18,
  J: 19,
  K: 20,
  L: 21,
  M: 22,
  N: 23,
  '&': 24,
  O: 25,
  P: 26,
  Q: 27,
  R: 28,
  S: 29,
  T: 30,
  U: 31,
  V: 32,
  W: 33,
  X: 34,
  Y: 35,
  Z: 36,
  ' ': 37,
  Ñ: 38,
};

export const claveHomonima = (nombreCompleto = '') => {
  const caracteres = nombreCompleto.split('').map((c) => valoresCaracteresParaSumatoriaClaveHomonima[c]);
  const valores = `0${caracteres.join('')}`;
  let sum = 0;
  for (let idx = 0; idx < valores.length - 1; idx += 1) {
    const element = valores.substring(idx, idx + 2);
    sum += element * element[1];
  }
  const ultimos3 = parseInt(sum.toString().substring(sum.toString().length - 3), 10);
  const cociente = parseInt(ultimos3 / 34, 10);
  const residuo = ultimos3 - (cociente * 34);
  const clave = `${residuoCocienteACaracter[cociente]}${residuoCocienteACaracter[residuo]}`;
  return clave;
};

export const digitoVerificadorRFC = (rfc) => {
  let sum = rfc.length === 12 ? 0 : 481;
  for (let idx = 0; idx < rfc.length; idx += 1) {
    // console.log(`[${rfc[idx]}]`, caracteresDigitoVerificador[rfc[idx]]);
    // console.log('val', (caracteresDigitoVerificador[rfc[idx]] || 0) * (rfc.length + 1 - idx));
    sum += (caracteresDigitoVerificador[rfc[idx]] || 0) * (13 - idx);
  }
  // console.log('[sum]', sum);
  const cociente = parseInt(sum / 11, 10);
  const residuo = sum - (cociente * 11);
  // console.log('[cociente]', cociente);
  // console.log('[residuo]', residuo);
  if (residuo === 0) return '0';
  if (residuo === 10) return 'A';
  const result = 11 - residuo;
  if (result === 10) return 'A';
  return result.toString();
};

// Decimales
const MAX_PRE_DIGIT_COUNT = 12;
const MAX_POST_DIGIT_COUNT = 8;
const DEFAULT_PRE_DIGIT_COUNT = 12;
export const DEFAULT_DECIMAL_DIGITS = 2;
/**
 * Función para crear expreciones regulares para valores decimales
 * @param pre digitos a la izquierda del punto decimal
 * @param post digitos a la derecha del punto decimal
 * @param req el valor es requerido
 * @param allowNegative el valor puede ser negativo
 */
export const createDecimalRegExp = (moneda = null, config = {}) => {
  let {
    pre = DEFAULT_PRE_DIGIT_COUNT,
    post = moneda?.decimales || DEFAULT_DECIMAL_DIGITS,
  } = config;
  const { req = false, allowNegative } = config;
  pre = pre > MAX_PRE_DIGIT_COUNT ? MAX_PRE_DIGIT_COUNT : pre;
  post = post > MAX_POST_DIGIT_COUNT ? MAX_POST_DIGIT_COUNT : post;
  const regexp = new RegExp(`^${allowNegative ? '-?' : ''}(\\d){${req ? 1 : 0},${pre}}(\\.\\d{0,${post}})?$`);
  const maxLength = pre + post + 1;
  return [regexp, maxLength + !!allowNegative];
};

export const RFC_VALIDATOR = (tipoDePersona) => ({
  validator: async (_, _value) => {
    if (_value) {
      const value = _value.toString().toUpperCase();
      if (value.length !== (tipoDePersona === 1 ? 13 : 12)) {
        throw new Error('Longitud inválida');
      }
      if (!RFC_PATTERN.test(value)) {
        throw new Error('Ingrese un RFC válido');
      }
      const _digitoVerificador = value.substring(value.length - 3, value.length - 1);
      if (digitoVerificadorRFC(value.substring(0, value.length - 3)) !== _digitoVerificador) {
        throw new Error('Dígito verificador inválido');
      }
    }
  },
});

export default {
  RFC_PATTERN,
  CURP_PATTERN,
  INE_PATTERN,
  createDecimalRegExp,
  digitoVerificador,
};
